import get from 'lodash/get';

const baseSelector = state => get(state, 'features.employers');
const getIsLoading = state => baseSelector(state).isLoading;
const getIsEmployerProfile = state => baseSelector(state).isEmployerProfile;
const getHasMultipleEmployers = state => baseSelector(state).hasMultipleEmployers;
const getCurrentEmployer = state => baseSelector(state).currentEmployer;
const getCurrentSubEmployer = state => baseSelector(state).currentSubEmployer;
const getJobcaseEmployerAdminLevel = state => baseSelector(state).jobcaseEmployerAdminLevel;
const getAllEmployerGrants = state => baseSelector(state).grants || {};
const getEmployerGrantsById = id => (state) => {
  const grants = getAllEmployerGrants(state);
  if (get(grants, '*', []).length !== 0) {
    return [...get(grants, '*', [])];
  }
  return get(grants, `[${id}]`, []);
};
const getHasAllEmployersGrants = state => baseSelector(state).grants?.['*'] || false;

export {
  getIsLoading,
  getIsEmployerProfile,
  getHasMultipleEmployers,
  getCurrentEmployer,
  getCurrentSubEmployer,
  getAllEmployerGrants,
  getEmployerGrantsById,
  getJobcaseEmployerAdminLevel,
  getHasAllEmployersGrants,
};

export default {
  getIsLoading,
  getIsEmployerProfile,
  getHasMultipleEmployers,
  getCurrentEmployer,
  getCurrentSubEmployer,
  getAllEmployerGrants,
  getEmployerGrantsById,
  getJobcaseEmployerAdminLevel,
  getHasAllEmployersGrants,
};
